// Import interfaces from models
import {type AppConfig, LogLevel} from './models';

let LEVEL:string = "prod";


const dev: AppConfig = {
    iva : 22,
    debug: true,
    logEnabled: true,
    logLevel: LogLevel.Debug,
    //googleMapApiKey : 'AIzaSyC8hkqKR6ugzF1yUmy5d7vB49pTRhs9UTg',
    apiServer: 'http://localhost:4242'

};

const preprod: AppConfig = {
    iva : 22,
    debug: true,
    logEnabled: true,
    logLevel: LogLevel.Debug,
    //googleMapApiKey : 'AIzaSyC8hkqKR6ugzF1yUmy5d7vB49pTRhs9UTg',
    apiServer: 'https://devapi.topupgym.pro',
};

const prod: AppConfig = {
    iva : 22,
    debug: false,
    logEnabled: true,
    logLevel: LogLevel.Warning,
    //googleMapApiKey : 'AIzaSyC8hkqKR6ugzF1yUmy5d7vB49pTRhs9UTg',
    apiServer: 'https://api.topupgym.pro',
};

let config: AppConfig;

switch (LEVEL) {
    case "prod":
        config = prod
        break;
    case "preprod":
        config = preprod;
        break;
    case "dev":
    default:
        config = dev;
        break;
}

export default config;
